import React from 'react';
import Image from '../../../../../components/common/image/image';
import Marquee from '../../../../../components/common/marquee/marquee';
import './menu-item.less';

export default class MenuItem extends React.Component<any, any> {
  static defaultProps = {
    levelInfo: {},
    onClickItem: null,
    referWidth: null,
    referHeight: null,
    containerWidth: null,
    type: '',
    imageId: '',
    title: '',
    active: false,
    activeBar: '',
    style: {},
    activeStyle: {},
    direction: 'h',
    tabIconNormal: '',
    tabIconActive: '',
    housetypeItemInfo: {
      name: '',
      desc: '',
      area: '',
      planThumb: '',
    },
  };
  clickItem = (e) => {
    const { onClickItem } = this.props;
    onClickItem && onClickItem(e);
  };

  render() {
    const {
      imageId,
      active,
      title,
      type,
      tabIconNormal,
      tabIconActive,
      direction,
      style,
      activeStyle,
      activeBar,
      thumb,
      housetypeItemInfo,
    } = this.props;

    if (!type) return null;

    const activeClassName = active ? 'active' : ''; // 选中

    const defaultAttrs = {
      style: Object.assign({}, style, active && activeStyle),
      onClick: this.clickItem,
    };

    switch (type) {
      case 'imgAndTit':
        return (
          <div className={`thumb-item ${direction} ${activeClassName}`} {...defaultAttrs}>
            <Image className='thumb-item-image' src={thumb} />
            <Marquee className='thumb-item-text' speed={0.2} text={title} />
          </div>
        );
      case 'imgAndTit2':
        return (
          <div className={`menu-scene-item ${direction} ${activeClassName}`} {...defaultAttrs}>
            <Image src={thumb} className='thumb' />
            <div className='title'>
              <Marquee className='value' text={title} />
            </div>
          </div>
        );
      case 'icnAndTit':
        return (
          <div className={`scroll-item ${activeClassName}`} {...defaultAttrs}>
            {tabIconNormal && tabIconActive ? (
              <Image className='icon' src={active ? tabIconActive : tabIconNormal} />
            ) : null}
            <div className='name'> {title} </div>
            {active ? <div className='active-bar' style={{ backgroundColor: activeBar }} /> : null}
          </div>
        );
      case 'title':
      case 'title2':
      case 'title3':
      case 'title4':
        const titleClassDictionaries = {
          title: 'scroll-item-small',
          title2: 'scroll-item-small-2',
          title3: 'scroll-item-small-3',
          title4: 'scroll-item-small bgc-none',
        };
        const titleClass = titleClassDictionaries[type];
        return (
          <div className={`${titleClass} ${direction} ${activeClassName}`} {...defaultAttrs}>
            <div className='name'> {title} </div>
          </div>
        );
      case 'housetypeItem':
        return (
          <div className={`house-type-item ${activeClassName}`} {...defaultAttrs}>
            <div className='info-card'>
              <div className='house-name'>{housetypeItemInfo.name}</div>
              <div className='desc-container'>
                <div className='desc'>{housetypeItemInfo.desc}</div>
                <div className='area'>建面约：{housetypeItemInfo.area}m²</div>
              </div>
            </div>
            {active && !housetypeItemInfo.hideLink ? (
              <div className={`detail-card ${housetypeItemInfo.planThumb ? 'have-plan' : 'no-plan'}`}>
                {housetypeItemInfo.planThumb ? (
                  <Image src={housetypeItemInfo.planThumb} className='house-plan' />
                ) : null}
                <div
                  className='detail-link'
                  style={{
                    backgroundColor: housetypeItemInfo.linkBackgroundColor || '',
                    color: housetypeItemInfo.linkColor || '',
                  }}
                >
                  {' '}
                  点击查看详情{' '}
                </div>
              </div>
            ) : null}
          </div>
        );
      case 'img':
        return (
          <div {...defaultAttrs}>
            {active ? (
              <Image tag='img' className='image-item' id={`menu-${imageId}-active`} />
            ) : (
              <Image tag='img' className='image-item' id={`menu-${imageId}-normal`} />
            )}
          </div>
        );
    }
  }
}
